var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vat-preview-loading text-center py-4"},[_c('b-spinner',{attrs:{"variant":"primary","small":""}}),_c('p',{staticClass:"mt-2 mb-0 text-muted loading-text"},[_vm._v(" Đang tính toán... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }